/**
 *  Created by Shikha Gupta on 2021-09-15.
 */

import {TweenLite} from "gsap";

interface ILineStyle {
    lineWidth: number,
    color: number,
    alpha: number
}

export class StaticBetLine extends PIXI.Container {

    private _isPlayingWin: boolean;
    private _lineStyles: ILineStyle[];
    private _alphaTween: TweenLite;
    private betLineStyles = [
        {
            "lineWidth": 6,
            "color": 0,
            "alpha": 1
        },
        {
            "lineWidth": 3,
            "color": 16777155, //"#FFFFC3"
            "alpha": 1
        }
    ];

    constructor(points: number[][], index: number) {
        super();
        this._index = index;
        this._isPlayingWin = false;
        this.initLine(points);
    }

    private _index: number;

    get index(): number {
        return this._index;
    }

    public onShowStaticBetLine(index: number): void {
        if (index !== this._index) {
            return;
        }

        if (this._isPlayingWin) {
            return;
        }

        this.killTween();
        this._alphaTween = TweenLite.to(this, 0.1, {alpha: 1});
    }

    public onHideStaticBetLine(index: number): void {
        if (index !== this._index) {
            return;
        }

        if (this._isPlayingWin) {
            return;
        }

        this.killTween();
        this._alphaTween = TweenLite.to(this, 0.1, {alpha: 0});
    }

    public onShowWinBetLine(index: number): void {
        if (index !== this._index) {
            return;
        }

        this._isPlayingWin = true;

        this.killTween();
        this._alphaTween = TweenLite.to(this, 0.1, {alpha: 1});
    }

    public onHideWinBetLine(index: number): void {
        if (index !== this._index) {
            return;
        }

        this.onHideAllBetLines();
    }

    public onHideAllBetLines(): void {
        this._isPlayingWin = false;
        this.killTween();
        this._alphaTween = TweenLite.to(this, 0.33, {alpha: 0});
    }

    protected initLine(points: number[][]): void {
        this._lineStyles = this.betLineStyles;
        let line: PIXI.Graphics = new PIXI.Graphics();
        let lineWidth: number = 0;

        for (let i: number = 0; i < this._lineStyles.length; i++) {
            this.drawLine(line, points, this._lineStyles[i]);
            lineWidth = Math.max(lineWidth, this._lineStyles[i].lineWidth);
        }
        this.addChild(line);
    }

    protected drawLine(line: PIXI.Graphics, points: number[][], style: ILineStyle): void {
        line.lineStyle(style.lineWidth, style.color, style.alpha);
        line.moveTo((points[0][0]), (points[0][1]));
        if(points[0][0]!==-20){
            line.moveTo((points[0][0]+20), (points[0][1]));
        for (let i: number = 1; i < points.length; i++) {

                if (i === points.length - 1) {
                    line.lineTo((points[i][0]), (points[i][1]));
                }else if(i===points.length-2){
                    line.lineTo((points[i][0]+90), (points[i][1]));
                }else if(i===2){
                    line.lineTo((points[i][0]+50), (points[i][1]));
                }
                else {
                    line.lineTo((points[i][0]+57), (points[i][1]));
                }
            }
        }
        else{
            for (let i: number = 1; i < points.length; i++){
                if(i===1){
                    line.lineTo((points[i][0]+10), (points[i][1]+20));
                }else if(i===points.length-2){
                    line.lineTo((points[i][0]+50), (points[i][1]+20));
                }else if(i===points.length-1){
                    line.lineTo((points[i][0]+55), (points[i][1]+20));
                }
                else{
            line.lineTo((points[i][0] + 40), (points[i][1]+20));
        }}
    }}

    private getHighestPointY(points: number[][]): number {
        let y: number = points[0][1];
        for (let i: number = 1; i < points.length; i++) {
            y = Math.min(y, points[i][1]);
        }

        return y;
    }

    private killTween(): void {
        if (this._alphaTween && this._alphaTween.isActive()) {
            this._alphaTween.progress(1);
            this._alphaTween.kill();

        }
    }
}
